import type { SxProps, Theme } from '@mui/material';

// No height, overflow, or minHeight here on purpose: for /intelligence/* the layout's PageContent is
// the scroll owner (WorkspaceSurface is unconstrained), so taking either would clip a tall prompt box
// instead of letting the page scroll. PageContent already contributes 16px of horizontal padding on
// top of the inset below.
const rootBase = {
  boxSizing: 'border-box',
  marginInline: 'auto',
  // Only bites on ultrawide displays; at typical widths the 9% inset alone matches the design.
  maxWidth: 1600,
  paddingInline: '9%',
  width: '100%',
} as const;

// Empty state: the deep top inset is what floats the hero prompt down the page, per the mockups.
export const summaryDashboardRootSx: SxProps<Theme> = {
  ...rootBase,
  paddingBlock: '100px 48px',
};

// Populated: a much shallower top inset. The prompt bar sits at the top here and pins to the scroll
// container, so the hero spacing would read as dead space above it and delay the first tile.
export const summaryDashboardPopulatedRootSx: SxProps<Theme> = {
  ...rootBase,
  paddingBlock: '16px 48px',
};

// Stated once above the grid: a data failure hits every tile at once, so one line explains it
// rather than each card repeating the reason (and far better than one snackbar per tile).
export const dashboardDataErrorSx: SxProps<Theme> = {
  color: theme => theme.palette.red[400],
  fontSize: '0.8125rem',
  paddingBottom: 1.5,
};
